import React from 'react'
import { DatePicker } from 'antd'
import moment from 'moment'
import type { DatePickerProps as DatePickerPropsAnt } from 'antd'
import type { DatePickerProps as DatePickerPropsDefault } from './interface'
import styles from './index.less'

type DatePickerProps = Overwrite<DatePickerPropsDefault, DatePickerPropsAnt>

export default ({
    value,
    onChange,
    label,
    format = 'YYYY-MM-DD',
    isTimestamp = false,
    ...restProps
}: DatePickerProps) => {
    const interval = 1000

    return (
        <div className={styles.container}>
            {label ? <span className={styles.label}>{label}</span> : null}
            <DatePicker
                value={value ? moment(value) : undefined}
                onChange={rValue => {
                    if (!rValue) {
                        onChange?.(undefined)
                        return
                    }

                    if (isTimestamp) {
                        onChange?.(rValue.unix() * interval)
                    } else {
                        onChange?.(rValue.format(format))
                    }
                }}
                {...restProps}
            />
        </div>
    )
}
